import { Snackbar } from '@mui/material'
import SnackbarContent from '@mui/material/SnackbarContent'
import type React from 'react'
import { useState } from 'react'

// import "./CustomExplain.css";

type ConversationNotificationProps = {
  text?: string
}

export const ConversationNotification: React.FC<ConversationNotificationProps> = props => {
  const { text } = props
  // 文字列変換用
  const [open, setOpen] = useState(true)

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') return
    setOpen(false)
  }

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ mb: 8 }}
      >
        <SnackbarContent
          message={text}
          sx={{
            backgroundColor: '#a9a9a9',
            color: '#000000',
            fontWeight: 'bold',
            justifyContent: 'center',
            border: '2px solid #000',
            borderRadius: '12px',
            fontSize: '18px',
          }}
        />
      </Snackbar>
    </>
  )
}
